import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { useLocation } from 'react-router-dom';

import TrainingIcon from '@components/icons/Training.svg';
import { shouldShowHowToUse } from '../../helpers/shouldShowHowToUse';

export const HowToUse = () => {
  const { me } = useAuthContext();
  const { openModal } = useModalContext();
  const { pathname } = useLocation();

  const openHowToUseModal = () => {
    openModal(ModalNamesEnum.AutoScriptOneTutorialVideo);
  };

  if (!me || !shouldShowHowToUse(pathname ?? '')) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <button
        type="button"
        onClick={openHowToUseModal}
        className="min-h-9 items-center text-[var(--color-green-text)] text-xs font-medium leading-[150%] no-underline bg-[var(--color-green)] hover:bg-[var(--color-green-hover)] px-2 py-[5px] rounded-[5px] flex gap-1.5 whitespace-nowrap"
      >
        <TrainingIcon /> How To Use
      </button>
    </div>
  );
};
